import type { CampaignSubscriberResponse } from "@/types/codegen/data-contracts"

export type CampaignRegistrationPayload = {
  fullname?: string
  phone?: string
  email?: string
  invoiceNumber?: string
  branch?: string
  purchasingDate?: string
  campaign?: number | string
  campaignName?: string
}

export type CampaignRegistrationResult = {
  subscriber: CampaignSubscriberResponse
  emailSent: boolean
}

/**
 * Public-side campaign registration.
 * Route handler tạo bản ghi `campaign-subscriber` trong Strapi rồi mới gửi email,
 * nên form chỉ báo thành công khi dữ liệu đã được lưu.
 */
export const postCampaignRegistration = async (
  payload: CampaignRegistrationPayload,
): Promise<CampaignRegistrationResult> => {
  const response = await fetch("/api/campaign-registration", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => null)
    throw new Error(error?.message || "Failed to submit campaign registration")
  }

  return response.json()
}
